import { render } from "./credit-tab.vue?vue&type=template&id=1d2cbdf4"
import script from "./credit-tab.vue?vue&type=script&lang=js"
export * from "./credit-tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__